





















import { Component, Vue, Prop } from "vue-property-decorator";
import { BuyGetCouponRuleConfig } from "./model/buyGetCouponRuleConfig";
import CouponSelect from "@/components/coupon-select/index.vue";
import CouponTable from "../couponTable/index.vue";
import CouponDto from "../coupon/model/couponDto";
@Component({
  components: {
    CouponSelect,
    CouponTable
  }
})
export default class BuyGetCoupon extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {
      return {
        memberScope: "All",
        memberTags: [],
        cumulativeWithOtherDiscount: false,
        discounts: [],
        discountType: 0,
        value: 0,
        coupons: []
      };
    }
  })
  value!: BuyGetCouponRuleConfig;

  get valueUnit() {
    switch (this.value.discountType) {
      case 0:
        return "元";
      case 1:
        return "折";
      default:
        return "";
    }
  }

  couponSelectChange(list) {
    console.log(list);
    this.value.coupons = this.value.coupons.concat(
      list.map(x => {
        let item: CouponDto = {
          id: x.id,
          name: x.name,
          couponType: x.couponType,
          couponTypeDisplayName: x.couponTypeDisplayName,
          validDate: x.validDate,
          value: x.discountValue,
          limitValue: x.limitValue
        };
        return item;
      })
    );
  }
}
